<template>
  
  <div class="left-insurance-form" v-if="insuranceData">
    <div class="insurance-order">
      <div class="tips-box">
        <div class="tips">为了保障您的权益，请填写真实有效的信息。您填写的内容仅供投保使用，对于您的信息我们会严格保密。</div>
      </div>

      <!-- 基本信息 -->
      <base-insurance-info v-model="insuranceData" ref="baseInsuranceInfo"></base-insurance-info>

      <!-- 企业，指定投保人 -->
      <company-insurance-info v-model="insuranceData" ref="companyInsuranceInfo" v-if="currentInsuranceTypeIsCompany && insuranceData.for_who == 1"></company-insurance-info>

      <!-- 个人 -->
      <personal-insurance-info v-model="insuranceData" ref="personalInsuranceInfo" v-if="currentInsuranceTypeIsPersonal"></personal-insurance-info>


      <!-- 为个人投保，本人 就隐藏 -->
      <theInsured-list v-model="insuranceData"  ref="theInsuredList" v-if="!(currentInsuranceTypeIsPersonal && insuranceData.for_who === 1)"></theInsured-list>

      <!-- 底部投保按钮 -->
      <div class="next-step">
        <div class="next-protocol">
          <el-checkbox class="next-check" v-model="isProtocolAgreed"></el-checkbox>
          <span>我已确认并同意
            <a class="next-url" target="_blank" :href="insuranceData.clause">《保险条款》</a>和<span @click="uiSwitch.isProtocolShow = true" class="next-url">《投保人申明》</span>
          </span>
        </div>
        <el-button class="next-button" type="primary"
          @click="submitForm()">
          提交
        </el-button>
      </div>
    </div>


    <!-- 投保人申明弹窗 -->
    <el-dialog title="投保人申明" v-model="uiSwitch.isProtocolShow" class="protocol-wrap" :modal-append-to-body="false">
      <div class="protocol-content">
        <p v-for="(content, index) in insuranceCpsProtocol" :key="index">
          <span class="index">{{index + 1}}.</span>
          <span>{{content}}</span>
        </p>
      </div>
		  <el-button type="primary" @click="uiSwitch.isProtocolShow = false">确定</el-button>
	  </el-dialog>


    <insurance-confirm-dialog 
      :visible.sync="uiSwitch.showInsureConfirmationDialog"
      :insure-confirmation-applicant-list="uiSwitch.insureConfirmationApplicantList"
      :insurance-id="insuranceId"
      >
    </insurance-confirm-dialog>

  </div>


</template>


<script>
import baseInsuranceInfo from './components/base-insurance-info';
import companyInsuranceInfo from './components/company-insurance-info';
import personalInsuranceInfo from './components/personal-insurance-info';
import theInsuredList from './components/theInsured-list/theInsured-list';
import insuranceConfirmDialog from './components/insurance-confirm-dialog.vue';
import utils from '@/libs/utils';
import insuranceApi from '@/api/insurance-api';
import sensorsdata from 'sa-sdk-javascript';
import User from '@/libs/user.js';
import moment from 'moment';
import { insuranceCpsProtocol } from '@/datas/insurance-products';

export default {
  props: {
    value: {
      type: Object,
    },
    insuranceId: Number,
  },
  components: {
    baseInsuranceInfo,
    companyInsuranceInfo,
    personalInsuranceInfo,
    theInsuredList,
    insuranceConfirmDialog,
  },
  data() {
    return {
      insuranceData: undefined, 
      insuranceCpsProtocol,
      isProtocolAgreed: false, // 是否同意保险协议
      uiSwitch: {
        isProtocolShow: false, // 是否同意用户协议
        showInsureConfirmationDialog: false, // 多人个人投保确认弹窗
        insureConfirmationApplicantList: [
          // {
          //   err_msg: '谢谢最新消息',
          //   cName: '谢谢最新消息xxxxx',
          //   cardCode: 1233333,
          // },
          // {
          //   err_msg: '谢谢最新消息',
          //   cName: 'aaa',
          //   cardCode: 12,
          // },
          // {
          //   err_msg: '',
          //   cName: 'xxcxzcxzcxzcxzcxzc',
          //   cardCode: 123,
          // },
          // {
          //   err_msg: '',
          //   cName: '谁都啊搜惺惺惜惺惺',
          //   cardCode: 124,
          // },
        ], // 投保确认的申请人列表
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.insuranceData)) {
          this.insuranceData = utils.deepCopy(val);
        }
      },
      immediate: true,
      deep: true,
    },
    insuranceData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  computed: {
    // 当前选中的投保类型
    currentInsuranceTypeIsCompany() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 1;
    },
    currentInsuranceTypeIsPersonal() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 0;
    }, 
  },
  methods: {
    // 校验是否被保人有未成年人，有则提示。
    verifyAge() {
      return new Promise((resolve) => {
        let error = false;
        this.insuranceData.insurants.forEach(({ birthday }) => {
          if (!birthday) return;
          console.log('sdasdsadsaa', birthday);
          const birthYear = birthday.getFullYear();
          const birthMonth = birthday.getMonth() + 1;
          const birthDay = birthday.getDate();

          const now = new Date();
          const nowYear = now.getFullYear();
          const nowMonth = now.getMonth() + 1;
          const nowDay = now.getDate();

          const yearDiff = nowYear - birthYear;
          const monthDiff = nowMonth - birthMonth;
          const dayDiff = nowDay - birthDay;


          if (yearDiff < 18) {
            error = true;
          } else if (yearDiff === 18) {
            if (monthDiff < 0) {
              error = true;
            } else if (nowMonth - birthMonth === 0) {
              if (dayDiff < 0) {
                error = true;
              }
            }
          }
        });
        const alertFunc = () => {
          utils.msgbox.confirm('被保人为未成年人，投保人只能为父母或法定监护人', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            resolve();
          }).catch(() => {});
        };
        if (error) {
          alertFunc();
        } else {
          resolve();
        }
      });

    },

    // 保险订单下单请求对象
    buildInsuranceOrderParams() {
      const params = JSON.parse(JSON.stringify(this.insuranceData));
      params.insurance_id = this.insuranceId;

      // 如果是为本人投保，则把投保人，赋值给被保人
      if (params.insurance_type_id === 0 && params.for_who === 1) {
        params.insurants = [JSON.parse(JSON.stringify(params.applicant))];
      }

      // 如果是个人投保，需要传递一个回调连接
      if (params.insurance_type_id === 0) {
        params.callback_url = `${window.location.origin}/confirm-post-message?insuranceId=${params.insurance_id}`;
      }

      if (params.protect_days.indexOf('1年') > -1 && params.protect_days.length > 2) {
        params.extended = params.protect_days;
      }
      // 删除不需要请求的字段
      delete params.destinations;
      delete params.insure_date_range;
      delete params.balance_amount;
      delete params.logo;
      delete params.clause;
      delete params.job_set;

      params.for_who = this.insuranceData.for_who;

      // 将日期对象转换为iso类型日期字符串
      params.start_date = moment(params.start_date).format('YYYY-MM-DD');

      params.applicant.birthday = params.applicant.birthday ? moment(params.applicant.birthday).format('YYYY-MM-DD') : undefined;
      if (params.applicant.job) {
        params.applican.job = params.applican.job.join('-');
      }

      params.insurants.forEach((ins) => {
        ins.birthday = moment(ins.birthday).format('YYYY-MM-DD');
        if (ins.job) {
          ins.job = ins.job.join('-');
        }
      });

      // // 若是已经承保需要修改，要再传一个insuranceNum,随便带一个值------因为会存在把所有申请人删除，然后再添加新申请人的情况，导致错误；现在后端处理了
      // const insurant = params.insurants.find(it => it.insurance_num);
      // if (insurant) {
      //   params.pre_insurance_num = insurant.insurance_num;
      // }


      // 如果是企业还需要删除一些个人独有的字段
      if (this.currentInsuranceTypeIsCompany) {
        delete params.is_self_insure;
        delete params.mobile_phone;
        params.insurants.forEach((ins) => {
          delete ins.relation_id;
        });
      }


      // 判断个人投保时候，是否为被投保人本人投保，如果是也需要去除
      if (!params.is_self_insure) {
        delete params.mobile_phone;
      }

      return params;
    },

    // 验证所有表单
    validateAllForm() {
      return new Promise((resolve, reject) => {
        const refList = ['baseInsuranceInfo', 'companyInsuranceInfo', 'personalInsuranceInfo', 'theInsuredList'];
        const params = [];
        refList.forEach((name) => {
          if (this.$refs[name]) {
            params.push(this.$refs[name].validate());
          }
        });


        Promise.all(params).then(() => {
          resolve();
        }).catch((domId) => {
          reject();

          if (!domId) {
            utils.msg.warning('请检查标红选项！');
            return;
          }

          // 还需要额外校验其他内容
          if (domId === '#theInsuredList') {
            const flag = this.$refs.theInsuredList.validateRepeat(); // 里面有对应的msg提示，所以
            flag && utils.msg.warning('请检查标红选项！'); // 没有重复就是说明存在不符合规则的输入
            return;
          }

          utils.msg.warning('请检查标红选项！');
          const el = document.querySelector(domId);
          if (!el) return;
          window.scrollTo({
            top: el.offsetTop,
            behavior: 'smooth',
          });

        });
      });
    },

    // 分步提交表单
    async submitForm() {
      try {
        await this.validateAllForm();
        await this.verifyAge();
        MtaH5.clickStat('insuranceorder0next');
        if (this.isProtocolAgreed) {
          const loadingIns = this.$loading();
          insuranceApi.simpleInsure(this.buildInsuranceOrderParams()).then((data) => {
            loadingIns.close();
            sensorsdata.track('Submit_your_policy', {
              peer_name: User.peer.peer_name,
              visa_peer_id: User.peer.visa_peer_id,
            });
            // 个人投保，需要去投保确认页
            if (this.currentInsuranceTypeIsPersonal) {
              if (!data.applicant_set) return; 

              // 判断被投保人是否存在失败的，如果是则直接提示错误，不需要弹窗
              const firstErrorApplicant = data.applicant_set.find(it => it.err_msg);
              if (firstErrorApplicant) {
                this.$message.error(firstErrorApplicant.err_msg);
                return;
              } 

              // 如果为被保人本人投保，后端返回单个被保人则显示单人弹窗，多人显示多人弹窗
              if (this.insuranceData.is_self_insure) {
                this.uiSwitch.showInsureConfirmationDialog = true;
                this.uiSwitch.insureConfirmationApplicantList = data.applicant_set || [];
                return; 
              }

              // 如果不是被保人本人投保，则直接走单个详情
              this.uiSwitch.showInsureConfirmationDialog = true;
              this.uiSwitch.insureConfirmationApplicantList = data.applicant_set.slice(0, 1); // 存在返回多个被保人的情况
            } else {
              setTimeout(() => {
                this.$router.replace({ name: 'insurancePay', query: { insuranceId: data.insurance_id } });
              }, 200);
            }

          }).catch((e) => {
            if (e) console.log(e);
            loadingIns.close();
          });
        } else {
          utils.msg.warning('请阅读《保险条款》和《投保人申明》，勾选后可进行下一步操作！');
        }

      } catch (e) {
        console.log('eeeee', e);
      }
      
    },

  },
};
</script>


<style lang="less" scoped>
.insurance-order {
  width: 800px;
  background-color: #fff;
  box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
  .tips-box{
    padding: 20px 24px;
    .tips{
      background: #FFF6DD;
      border-radius:2px;
      height: 32px;
      padding: 0 12px;
      font-size: 14px;
      color: #FF8033;
      display: flex;
      align-items: center;
      &::before{
        content: "";
        width: 16px;
        height: 16px;
        background: url(../../../../../../assets/imgs/insurance-new/icon-tips.png) no-repeat center / 100% 100%;
        margin-right: 6px;
      }
    }
  }

  /deep/ .el-form-item {
    width: 50%;
    padding: 0 15px;
    margin-right: 0;
    &.w-100{
      width: 100%;
    }
    .form-item-label{
      color: #2F333D;
      font-size: 16px;
      line-height: 1;
      margin-bottom: 8px;
      .required{
        color: #FF6464;
        margin-left: 4px;
      }
      .sub-label{
        margin-left: 4px;
        color: #91999F;
        font-size: 14px;
      }
    }
    .subtitle {
      font-size: 12px;
      color: #2F333D;
      line-height: 1;
      margin-top: 8px;
    }
  }

  .order-block {
    .title{
      padding-left: 24px;
      display: flex;
      align-items: center;
      background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
      height: 44px;
      color: #2F333D;
      font-size: 18px;
      font-weight: 600;
      &.personal {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 24px;
        .self-btn {
          font-size: 14px;
          color: #5F666E;
          line-height: 20px;
          font-weight: normal;
          display: flex;
          align-items: center;
          /deep/ .el-switch {
            transform: scale(0.7);
            margin-right: 2px;
          }
        }
      }
    }
    .content {
      padding: 20px 24px;
      display: flex;
      flex-wrap: wrap;
      margin-left: -15px;
      margin-right: -15px;
      &.self-insure-content {
        display: flex;
        flex-direction: column;
        .applicant-list {
          display: flex;
          flex-wrap: wrap;
          .applicant-item {
            padding: 0 46px;
            height: 28px;
            line-height: 28px;
            background: #FAFBFC;
            border-radius: 2px;
            border: 1px solid #DEE2E6;
            margin-right: 16px;
            font-size: 14px;
            color: #2F333D;
          }
        }
      }
    }
  }
  .order-group-recognizee{
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      height: 44px;
      background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
      .header-title{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
      }
      .btn-box{
        a{
          color: #599FFF;
          font-size: 14px;
          margin-left: 24px;
        }
      }
    }
    .historical-applicant-list-wrapper {
      margin: 0 24px;
      padding: 20px 0;
      border-bottom: 1px dashed #E9EEF2;
    }

    .recognizee-box-wrap{
      padding: 20px 24px;
      .recognizee-table{
        background: #FAFBFC;
        border-spacing: 0;
        thead{
          th{
            border-bottom: 1px solid #E9EEF2;
            font-size: 14px;
            color: #2F333D;
            font-weight: 600;
            height: 44px;
          }
        }
        tbody{
          tr{
            &:first-child{
              td{
                padding-top: 20px;
              }
            }
            &:last-child{
              td{
                padding-bottom: 20px;
              }
            }
          }
          td{
            padding: 8px 5px;
            text-align: center;
            &.td-index{
              font-size: 12px;
              color: #2F333D;
            }
            .delete-btn{
              display: inline-block;
              background: url(../../../../../../assets/imgs/insurance-new/icon-delete.png) no-repeat center / 100% 100%;
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-right: 0;
            }
          }
        }
        /deep/ .el-form-item{
          width: 100%;
          padding: 0;
          margin-bottom: 0;
          .el-form-item__content{
            .el-date-editor{
              .el-input__icon{
                display: none;
              }
              .el-input__inner{
                padding: 3px 10px;
              }
            }
          }
        }
      }
    }
    .recognizee-add {
      margin: 0 auto;
      width:150px;
      height:36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background:rgba(89,159,255,0.08);
      font-size: 16px;
      color: #599FFF;
      cursor: pointer;
      border-radius: 18px;
      line-height: 1;
      margin-top: 20px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }
  .next-step {
    height: 82px;
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    background: #fff;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .next-protocol{
      font-size: 14px;
      color: #2F333D;
      line-height: 1;
      .next-check{
        /deep/ .el-checkbox__inner{
          width: 16px;
          height: 16px;
          &::after{
            left: 4px;
          }
        }
      }
      .next-url{
        color: #599FFF;
        cursor: pointer;
      }
    }
    .next-button{
      width:200px;
      height:50px;
      background: #599FFF;
      border-radius:2px;
      color: #fff;
      font-size: 16px;
    }
  }
}

.protocol-wrap {
  /deep/ .el-dialog {
    .el-dialog__header {
      font-size: 18px;
      color: #333;
      text-align: center;
      font-weight: bold;
      padding: 28px 20px 0px;
    }
    .el-button {
      width: 240px;
      height: 40px;
      margin: 0 auto;
      display: block;
    }
    .el-dialog {
      width: 760px;
      border-radius: 4px;
    }
    .protocol-content {
      padding: 0 40px;
      margin-bottom: 40px;
      p {
        margin-bottom: 15px;
        font-size: 14px;
        color: #6f6f6f;
        display: flex;
        line-height: 1.5;
        .index {
          margin-right: 5px;
        }
      }
    } 
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/left-insurance-form.vue